import { useCallback, useEffect, useState } from "react";
import {
  ResourceContextProvider,
  SimpleForm,
  Title,
  useNotify,
} from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackButtonToolbar from "features/BackButtonToolbar";
import { dormitoryRequests } from "api/dormitoryApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import { ACCOMMODATION_PRICES, DormitoryServicePath, PRICES, ROOM_TYPES } from "utils/constants";
import SaveForm from "../SaveForm";

const EditAccommodationPrice = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const navigate = useNavigate();
  const { typeId, id } = useParams();
  const roomTypeName = useLocation().state?.roomTypeName;
  const [defaultValues, setDefaultValues] = useState(null);

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        dormitoryRequests.getAccommodationPrice(typeId, id),
        null,
        "GET",
      );
      setDefaultValues(data);
    } catch (err) {
      console.error(err);
      notify("Грешка при зареждане на данни. Опитайте да презаредите страницата.", { type: "error" });
    }
  }, [typeId, id, notify]);

  useEffect(() => {
    if (typeId && id) {
      fetchDefaultValues();
    }
  }, [typeId, id, fetchDefaultValues]);

  const handleSubmit = async data => {
    try {
      await dataProvider.customRequest(
        dormitoryRequests.updateAccommodationPrice(typeId, id),
        {
          amount: data.amount,
          orderNumber: data.orderNumber,
          receptionTypeId: data.receptionTypeId,
          studentType: data.studentType,
          course: data.course,
          validFrom: data.validFrom,
          validTo: data.validTo,
        },
        "PUT",
      );
      notify("Успешно редактиране на цена за настаняване", { type: "success" });
      navigate(`/${DormitoryServicePath}${ACCOMMODATION_PRICES}`);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title
        title={
          roomTypeName
            ? `Редактиране на цена за настаняване: ${roomTypeName}`
            : "Редактиране на цена за настаняване"
        }
      />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${DormitoryServicePath}${ROOM_TYPES}/${typeId}/${PRICES}/${id}/edit`}>
        {defaultValues && (
          <SimpleForm
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
          >
            <SaveForm />
          </SimpleForm>
        )}
      </ResourceContextProvider>
    </>
  );
};

export default EditAccommodationPrice;
